"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPassengerFilled = function IconPassengerFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "IconPassengerFilled"), _react.default.createElement("path", {
    d: "M21.08 14.1C23.0296 14.1 24.61 12.5106 24.61 10.55C24.61 8.58939 23.0296 7 21.08 7C19.1304 7 17.55 8.58939 17.55 10.55C17.55 12.5106 19.1304 14.1 21.08 14.1Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M43.78 42.74L39.71 33.74C39.4059 33.064 38.9469 32.4691 38.3701 32.0035C37.7933 31.5378 37.115 31.2146 36.39 31.06L26.7 29L26.13 20.9C26.0677 19.697 25.5782 18.5558 24.7497 17.6814C23.9211 16.807 22.8079 16.2569 21.61 16.13C20.939 16.0832 20.2655 16.1754 19.6317 16.4007C18.998 16.6261 18.4175 16.9798 17.9266 17.4397C17.4357 17.8996 17.045 18.4558 16.7789 19.0736C16.5128 19.6913 16.377 20.3574 16.38 21.03V31.55C16.3774 32.1698 16.4968 32.7841 16.7316 33.3578C16.9664 33.9315 17.3119 34.4533 17.7483 34.8934C18.1847 35.3336 18.7036 35.6834 19.2752 35.9231C19.8469 36.1627 20.4602 36.2874 21.08 36.29H34.5C34.7054 36.2958 34.9056 36.3552 35.081 36.4622C35.2564 36.5691 35.4008 36.7201 35.5 36.9L39.89 44.9C40.0421 45.1776 40.2526 45.4189 40.5069 45.6073C40.7613 45.7956 41.0534 45.9267 41.3633 45.9913C41.6731 46.0559 41.9933 46.0526 42.3018 45.9816C42.6102 45.9106 42.8996 45.7736 43.15 45.58C43.5601 45.2472 43.8456 44.7854 43.9599 44.2698C44.0743 43.7542 44.0109 43.215 43.78 42.74V42.74Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M29 40.89C29.0013 41.1675 28.9476 41.4424 28.8421 41.699C28.7365 41.9556 28.5811 42.1887 28.3849 42.3849C28.1887 42.5811 27.9556 42.7365 27.699 42.8421C27.4424 42.9476 27.1675 43.0013 26.89 43H11.06C10.7797 42.9974 10.5116 42.8849 10.3133 42.6866C10.1151 42.4884 10.0026 42.2203 9.99999 41.94V17.11C9.99867 16.8325 10.0523 16.5576 10.1579 16.301C10.2635 16.0444 10.4188 15.8112 10.615 15.615C10.8112 15.4188 11.0444 15.2635 11.301 15.1579C11.5576 15.0523 11.8325 14.9987 12.11 15V15C12.3875 14.9987 12.6624 15.0523 12.919 15.1579C13.1756 15.2635 13.4087 15.4188 13.6049 15.615C13.8011 15.8112 13.9565 16.0444 14.0621 16.301C14.1676 16.5576 14.2213 16.8325 14.22 17.11V38.26C14.22 38.3979 14.2748 38.5302 14.3723 38.6277C14.4698 38.7252 14.6021 38.78 14.74 38.78H26.89C27.1675 38.7787 27.4424 38.8323 27.699 38.9379C27.9556 39.0435 28.1887 39.1988 28.3849 39.395C28.5811 39.5912 28.7365 39.8244 28.8421 40.081C28.9476 40.3376 29.0013 40.6125 29 40.89V40.89Z",
    fill: color
  }));
};

IconPassengerFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconPassengerFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconPassengerFilled;
exports.default = _default;